/**
 * @generated SignedSource<<53c81e032635f306651163baf5c880f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TokenAmountAsCurrencyDisplayFragment$data = {
  readonly amount: string;
  readonly currency: string;
  readonly decimals: number;
  readonly " $fragmentType": "TokenAmountAsCurrencyDisplayFragment";
};
export type TokenAmountAsCurrencyDisplayFragment$key = {
  readonly " $data"?: TokenAmountAsCurrencyDisplayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TokenAmountAsCurrencyDisplayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TokenAmountAsCurrencyDisplayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "decimals",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    }
  ],
  "type": "TokenAmount",
  "abstractKey": null
};

(node as any).hash = "6ecf13b5bbddfedf9aabd502ac04e39f";

export default node;
